import React from 'react';
import tpl from '../templates/childrens';
import BaseNewCardView from '../../views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            tab: 'tariffs'
        };
    }

    static displayName = 'Childrens.Views.Main';
}
